import React, { useRef } from 'react'
import styled from 'styled-components'
import ScanInput, { IRef } from '../../../kosherTeudot/Components/ScanInput'
import CircleActiveFilterBtn from '../../../../../../generic/particles/CircleActiveFilterBtn'
import BarCodeIcon from '../../../../../../generic/icons/IconLib/BarcodeIcon'
import DeleteIcon from '../../../../../../generic/icons/IconLib/TrashIcon'
import AcceptIcon from '../../../../../../generic/icons/IconLib/CheckIcon'
import { handleNotifications } from '../../../../../../generic/utils/handleNotifications'
import { ISrikaItem } from '../../../../../../modules/API/Gathering/models/srika'
import PalletProductCard from './PalletProductCard'

type Props = {
  palletData: ISrikaItem | null
  handleScanPallet: (pallet: string) => void
  clearScannedDataPallet: () => void
  input: string
  setInput: (s: string) => void
}

const ScanPalletCard = ({
  clearScannedDataPallet,
  handleScanPallet,
  palletData,
  input,
  setInput,
}: Props) => {
  const refInput = useRef<IRef>(null)

  const handleClearScannedDataPallet = () => {
    clearScannedDataPallet()
  }
  const handleScan = () => {
    if(palletData) {
      handleNotifications("משטח כבר נבחר", { type: "warning" });
      return
    }
    // format input 1063-1
    const match = input.match(/^(\d+)-(\d+)$/i)
    if(!match) {
      handleNotifications("מספר משטח לא תקין", { type: "warning" });
      return
    }
    
    handleScanPallet(input)
  }
  return (
    <MainWrapper>
       <Title>
       ברקוד כניסה
       </Title>
       <BlockWrapper>
        {
          palletData ? (
            <CircleActiveFilterBtn
              func={handleClearScannedDataPallet}
            >
              <DeleteIcon />
            </CircleActiveFilterBtn>
          ) :
          input && input.length > 0 && (
          <CircleActiveFilterBtn
            func={handleScan}
          >
            <AcceptIcon />
          </CircleActiveFilterBtn>
          )
        }
        
        <ScanInput 
          ref={refInput}
          setInput={setInput}
          input={input}
          enterFunc={handleScan}
          icon={<BarCodeIcon />}
        />
        </BlockWrapper>
        {palletData && (
          <BlockWrapper>
            <PalletProductCard palletData={palletData} />
          </BlockWrapper>
        )}
      
      
    </MainWrapper>
  )
}
const MainWrapper = styled.div`
  padding: 0.2em;
  border-radius: 30px;
  background: #f2f2f2;
  display: flex;
  flex-flow: column;
  gap: 0.2em;
`
const Title = styled.h3`
  font-size: 1em;
  font-weight: 600;
  text-align: center;
  color: #297F76;
`
const BlockWrapper = styled.div`
  width: 100%;
  padding: 0.1em;
  display: flex;
  gap: 0.2em;
  border-radius: 30px;
  background: #fff;
`

export default ScanPalletCard